import React from "react";
import styles from "./Header.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

function Header(props: any) {
  return (
    <header>
      <a href="https://zacharyc.com/resume/">
        <h1 className={styles.personName}>
          <span>
            Zach
            <span className={styles.backwardA}>a</span>
            ry
          </span>
          <span> Cohen</span>
        </h1>
      </a>
      <ul className={styles["contact-info"]}>
        <li>
          <a href="mailto:zachary@zacharyc.com">
            <FontAwesomeIcon icon={faEnvelope} />
            zachary@zacharyc.com
          </a>
        </li>
        <li>
          <a href="tel:1-203-919-0208">
            <FontAwesomeIcon icon={faPhone} />
            203-919-0208
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/zacharyc/">
            <FontAwesomeIcon icon={faLinkedin} />
            zacharyc
          </a>
        </li>
        <li>
          <a href="https://www.github.com/zacharyc">
            <FontAwesomeIcon icon={faGithub} />
            zacharyc
          </a>
        </li>
        {/* <li>
          <a href="https://maps.app.goo.gl/TDcoa8RdhMLr3eku7">
            <FontAwesomeIcon icon={faLocationDot} />
            Newport, RI <span className={styles.zipCode}>02840</span>
          </a>
        </li> */}
        <li>
          <a href="https://maps.app.goo.gl/TDcoa8RdhMLr3eku7">
            <FontAwesomeIcon icon={faLocationDot} />
            Westminster, CO <span className={styles.zipCode}>80031</span>
          </a>
        </li>
      </ul>
    </header>
  );
}

export default Header;
